import RemoteAuditContainer from "./RemoteAuditContainer";

export default RemoteAuditContainer;